import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { Subscription } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { PublicAccessTerminalService } from './public-access-terminal.service';

const automatic_retry_interval_ms = 30000; // 30 seconds
@Component({
  selector: 'app-public-access-terminal',
  templateUrl: './public-access-terminal.component.html',
  styleUrls: ['./public-access-terminal.component.less']
})
export class PublicAccessTerminalComponent implements OnDestroy, OnInit {
  reauthenticationInProgress = false;
  private intervalSubscription: Subscription;

  constructor(public authenticationService: AuthenticationService,
              private publicAccessTerminalService: PublicAccessTerminalService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    const isUserTryingToEraseLocalStorageKey = this.route.snapshot.queryParamMap.get('reset') === 'true';
    const desiredPATValue = !isUserTryingToEraseLocalStorageKey;

    this.publicAccessTerminalService.setAsPublicAccessTerminal(desiredPATValue);

    // If user is doing ?reset=true, clear the session and go to /
    if (isUserTryingToEraseLocalStorageKey) {
      this.authenticationService.clearSession();
      this.router.navigate(['/']);
    } else {

      // listen for success or failure from the authentication attempt
      this.authenticationService.patAuthentication$.subscribe(value => {
        if (this.intervalSubscription) {
          this.intervalSubscription.unsubscribe();
        }
        // Go to the landing on success, retry authentication repeatedly on failure
        if (value) {
          this.router.navigate(['/']);
        } else {
          let ticker = IntervalObservable.create(automatic_retry_interval_ms);
          this.intervalSubscription = ticker.subscribe(() => { this.attemptAuthentication(); });
        }
      });
      this.attemptAuthentication();
    }
  }

  attemptAuthentication() {
    this.reauthenticationInProgress = true;
    this.authenticationService.authenticateViaClientCertificate()
      .then(success => {
        if (success) {
          this.router.navigate(['/']);
        } else {
          this.reauthenticationInProgress = false;
        }
      });
  }

  ngOnDestroy() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/public-access-terminal.component.ts